import { useEffect, useState } from 'react';
import { useAuth } from '../../context/AuthContext';
import { Link, useNavigate } from 'react-router-dom';
import { Button } from '../../components/ui/button';
import { Badge } from '../../components/ui/badge';
import { ArrowLeft } from 'lucide-react';
import { getAllUsers } from '../../lib/firebaseService';

export default function AdminUsers() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!user?.is_admin) {
      navigate('/dashboard');
      return;
    }
    loadUsers();
  }, [user, navigate]);

  const loadUsers = async () => {
    try {
      const usersData = await getAllUsers();
      setUsers(usersData);
    } catch (error) {
      console.error('İstifadəçilər yüklənə bilmədi:', error);
    } finally {
      setLoading(false);
    }
  };

  const formatDate = (timestamp) => {
    if (!timestamp) return '-';
    if (timestamp.toDate) {
      return timestamp.toDate().toLocaleDateString('az-AZ');
    }
    return new Date(timestamp).toLocaleDateString('az-AZ');
  };

  return (
    <div className="min-h-screen bg-slate-50" data-testid="admin-users-page">
      <header className="bg-white border-b border-border">
        <div className="container mx-auto px-4 py-4">
          <div className="flex items-center gap-4">
            <Link to="/admin">
              <Button variant="ghost" size="sm">
                <ArrowLeft className="w-4 h-4 mr-2" />
                Geri
              </Button>
            </Link>
            <h1 className="text-2xl font-bold">İstifadəçilər</h1>
          </div>
        </div>
      </header>

      <main className="container mx-auto px-4 py-8">
        {loading ? (
          <p>Yüklənir...</p>
        ) : users.length === 0 ? (
          <div className="bg-white rounded-xl border border-border p-12 text-center">
            <p className="text-muted-foreground">Heç bir istifadəçi yoxdur</p>
          </div>
        ) : (
          <div className="bg-white rounded-xl border border-border overflow-hidden">
            <div className="overflow-x-auto">
              <table className="w-full">
                <thead className="bg-slate-50 border-b border-border">
                  <tr>
                    <th className="text-left p-4 font-semibold">Ad</th>
                    <th className="text-left p-4 font-semibold">Email</th>
                    <th className="text-left p-4 font-semibold">Telefon</th>
                    <th className="text-left p-4 font-semibold">Rol</th>
                    <th className="text-left p-4 font-semibold">Qeydiyyat Tarixi</th>
                  </tr>
                </thead>
                <tbody>
                  {users.map((userItem) => (
                    <tr key={userItem.id} className="border-b border-border hover:bg-slate-50">
                      <td className="p-4">{userItem.full_name || '-'}</td>
                      <td className="p-4">{userItem.email}</td>
                      <td className="p-4">{userItem.phone || '-'}</td>
                      <td className="p-4">
                        {userItem.is_admin ? (
                          <Badge className="bg-red-100 text-red-700">Admin</Badge>
                        ) : (
                          <Badge variant="outline">İstifadəçi</Badge>
                        )}
                      </td>
                      <td className="p-4 text-sm text-muted-foreground">
                        {formatDate(userItem.created_at)}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        )}
      </main>
    </div>
  );
}
